// auth/perm.ts

export function matchWithWildcard(perms, key) {
  if (!Array.isArray(perms)) return false;
  if (perms.includes("*") || perms.includes("platform:*")) return true;
  if (perms.includes(key)) return true;
  const parts = key.split(":");
  for (let i = parts.length; i >= 1; i--) {
    const cand = parts.slice(0, i).join(":") + ":*";
    if (perms.includes(cand)) return true;
  }
  return false;
}
const RESOURCES = [
  "users",
  "exams",
  "results",
  "grading",
  "categories",
  "dashboard",
];

/** read روی یک ریسورس */
export function canRead(user, resource) {
  const perms = user?.perms || [];
  return matchWithWildcard(perms, `org:${resource}:read`);
}

/** write روی یک ریسورس */
export function canWrite(user, resource) {
  const perms = user?.perms || [];
  // write → خود write یا org:* یا platform:* مجاز است
  return matchWithWildcard(perms, `org:${resource}:write`);
}

/** اگر write داشته باشد، برای UI می‌توانیم read را هم true در نظر بگیریم */
export function canReadOrWrite(user, resource) {
  return canWrite(user, resource) || canRead(user, resource);
}

// ⬅️ حالا makeHasPerm هم با permsِ تجمیع‌شده کار می‌کند
export function makeHasPerm(userOrPerms) {
  const perms = Array.isArray(userOrPerms)
    ? userOrPerms
    : getEffectivePerms(userOrPerms);
  return (key) => matchWithWildcard(perms, key);
}

export function isOrgUser(userOrPerms) {
  const perms = Array.isArray(userOrPerms)
    ? userOrPerms
    : getEffectivePerms(userOrPerms);
  return perms.some(
    (k) =>
      typeof k === "string" &&
      (k.startsWith("org:") || k.startsWith("platform:"))
  );
}

export function getEffectivePerms(user) {
  const a = Array.isArray(user?.perms) ? user.perms : [];
  const b = Array.isArray(user?.permissions)
    ? user.permissions
        .map((p) => (typeof p === "string" ? p : p?.key))
        .filter(Boolean)
    : [];
  return Array.from(new Set([...a, ...b]));
}
